// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    aboutToDelete: {
        id: 'info-panel.about-to-delete',
        defaultMessage: 'You are about to delete {device}.'
    },
    battery: {
        id: 'info-panel.mains-battery',
        defaultMessage: 'Battery'
    },
    cancel: {
        id: 'info-panel.cancel',
        defaultMessage: 'Cancel'
    },
    cancelOrConfirm: {
        id: 'info-panel.cancel-or-confirm',
        defaultMessage: 'Please cancel to return to the device screen or confirm you wish to delete'
    },
    cancelOrConfirmZone: {
        id: 'info-panel.cancel-or-confirm-zone',
        // eslint-disable-next-line max-len
        defaultMessage:
            'Please cancel to return to the device screen or confirm you wish to delete the thermostat and receiver for this zone.'
    },
    connectedDevices: {
        id: 'info-panel.connected-devices',
        defaultMessage: `Devices`
    },
    connectedDevicesNumber: {
        id: 'info-panel.connected-devices-number',
        defaultMessage: `{connectedDevices, plural,
    			one {Light}
    			other {Lights}
    		}`
    },
    firmwareVersion: {
        id: 'info-panel.firmware-version',
        defaultMessage: 'Firmware version'
    },
    hubUptime: {
        id: 'info-panel.hub-up-time',
        defaultMessage: 'Hub uptime'
    },
    internetConnection: {
        id: 'info-panel.internet-connection',
        defaultMessage: 'Internet connection'
    },
    invalidCharacters: {
        id: 'info-panel.invalid-chars',
        defaultMessage: 'Please enter a valid device name - use only letters and numbers'
    },
    ipAddress: {
        id: 'info-panel.ip-address',
        defaultMessage: 'IP Address'
    },
    link: {
        id: 'info-panel.link',
        defaultMessage: 'Link'
    },
    macAddress: {
        id: 'info-panel.mac-address',
        defaultMessage: 'MAC Address'
    },
    mains: {
        id: 'info-panel.mains',
        defaultMessage: 'AC'
    },
    manufacturer: {
        id: 'info-panel.manufacturer',
        defaultMessage: 'Manufacturer'
    },
    modalRemoveDevice: {
        id: 'modal-remove-device',
        defaultMessage: 'Remove device'
    },
    nickname: {
        id: 'info-panel.edit-device-name',
        defaultMessage: 'Edit device name'
    },
    passwordLength: {
        id: 'info-panel.nickname-length',
        defaultMessage: 'Nickname must be less than 20 characters'
    },
    philips: {
        id: 'info-panel.philips',
        defaultMessage: 'Philips lighting'
    },
    powerSource: {
        id: 'info-panel.power-source',
        defaultMessage: 'Power source'
    },
    removeDevice: {
        id: 'info-panel.remove-device',
        defaultMessage: 'Remove'
    },
    removeDeviceTitle: {
        id: 'info-panel.remove-device-title',
        defaultMessage: 'Remove device'
    },
    removePartner: {
        id: 'info-panel.remove-partner',
        defaultMessage: 'Remove partner'
    },
    removeZoneTitle: {
        id: 'info-panel.remove-zone-title',
        defaultMessage: 'Remove zone'
    },
    required: {
        id: 'info-panel.validation-required',
        defaultMessage: 'Please enter a nickname'
    },
    restartHub: {
        id: 'info-panel.restart-hub',
        defaultMessage: 'Restart Hub'
    },
    restarting: {
        id: 'info-panel.restarting',
        defaultMessage: 'Restarting'
    },
    save: {
        id: 'info-panel.save',
        defaultMessage: 'Save'
    },
    serialNumber: {
        id: 'info-panel.serial-number',
        defaultMessage: 'Serial Number'
    },
    support: {
        id: 'info-panel.support',
        defaultMessage: 'Customer support'
    },
    wired: {
        id: 'info-panel.mains-wired',
        defaultMessage: 'Ethernet'
    },
    zoneNickname: {
        id: 'info-panel.edit-zone-name',
        defaultMessage: 'Edit zone name'
    }
});



// WEBPACK FOOTER //
// ./src/components/widgets/device-info-panel/intl.js